<template>
	<div :style="{direction: $vs.rtl ? 'rtl' : 'ltr'}">
		<feather-icon
			v-if="resourceUpdatePermission"
			icon="EditIcon"
			svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
			@click="editRecord"
		/>
		<feather-icon
			icon="FileTextIcon"
			svgClasses="h-5 w-5 mr-2 hover:text-warning cursor-pointer"
			:title="$t('SeeDetailedInformation')"
			@click="seeDetailInformation"
		/>
		<feather-icon
			v-if="resourceDeletePermission"
			icon="Trash2Icon"
			svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
			@click="confirmDeleteRecord"
		/>
	</div>
</template>

<script>
import moduleResource from "@/store/resource/moduleResource.js";

export default {
	name: "CellRendererActions",
	computed: {
		resourceUpdatePermission() {
			return this.$store.getters.checkPermission("RESOURCES_U");
		},
		resourceDeletePermission() {
			return this.$store.getters.checkPermission("RESOURCES_D");
		},
	},
	methods: {
		editRecord() {
			this.$router.push(`/dashboard/resource-edit/${this.params.data.id}`).catch(() => {});
		},
		seeDetailInformation() {
			this.$router.push("/apps/resource/resource-view/" + this.params.data.id).catch(() => {});
		},
		seeRecord() {
			this.$router.push(`/dashboard/resource-edit/${this.params.data.id}`);
		},
		confirmDeleteRecord() {
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Confirm"),
				text: this.$t("ResourceModule.Messages.Delete") + " " + this.params.data.username,
				accept: this.deleteRecord,
				acceptText: this.$t("Accept"),
				cancelText: this.$t("Cancel"),
			});
		},
		deleteRecord() {
			this.$vs.loading();
			this.$store
				.dispatch("moduleResource/removeResource", this.params.data.id)
				.then((res) => {
					this.$vs.loading.close();
					this.$vs.notify({
						color: "success",
						title: this.$t("ResourceModule.Messages.TitleDeleted"),
						text: this.$t("ResourceModule.Messages.Deleted"),
					});
				})
				.catch((err) => {
					console.error(err);
					this.$vs.loading.close();
					this.$vs.notify({
						color: "danger",
						title: this.$t("Error"),
						text: this.$t("ResourceModule.Table.Errors.Delete"),
					});
				});
		},
	},
	created() {
		if (!moduleResource.isRegistered) {
			this.$store.registerModule("moduleResource", moduleResource);
			moduleResource.isRegistered = true;
		}
	},
};
</script>
